// Chakra imports
import {
  Portal,
  useDisclosure,
  Stack,
  Box,
  useColorMode,
  Link,
} from "@chakra-ui/react";
import Configurator from "components/Configurator/Configurator";
import Footer from "components/Footer/Footer.js";
import {
  ArgonLogoDark,
  ArgonLogoLight,
  ChakraLogoDark,
  ChakraLogoLight,
} from "components/Icons/Icons";
// Layout components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import React, { useEffect, useState } from "react";
import { Redirect, Route, Switch,useHistory } from "react-router-dom";
import routes from "routes.js";
// Custom Chakra theme
import FixedPlugin from "../components/FixedPlugin/FixedPlugin";
import {loginPermissionDetail} from "../actions/authActions";
// Custom components
import MainPanel from "../components/Layout/MainPanel";
import PanelContainer from "../components/Layout/PanelContainer";
import PanelContent from "../components/Layout/PanelContent";
import bgPlantAdmin from "assets/img/test.png";
import bgAdmin from "assets/img/image3.png";
import bgCityAdmin from "assets/img/image2.png";
import dataConstant from "constants/dataConstant";


import { IoArrowBackSharp } from 'react-icons/io5';
import { useSelector } from "react-redux";

export default function Dashboard(props) {
  const authDetail = useSelector((state) => state.auth.authDetail);
  const loading = useSelector((state) => state.auth.loading);
  const history = useHistory();
  useEffect(() => {
    loginPermissionDetail();
  }, [loginPermissionDetail]);

  const [designation, setDesignation] = useState('');
  useEffect(() => {
    setDesignation(authDetail.role?.name);
  }, [loading]);

  const { ...rest } = props;
  // states and functions
  const [fixed, setFixed] = useState(false);
  const { colorMode } = useColorMode();
  // functions for changing the states from components
  const getRoute = () => {
    return window.location.pathname !== "/admin/full-screen-maps";
  };
  const handeGoback = () =>
  {
    history.goBack()
  }
  const getActiveRoute = (routes) => {
    console.log("routes/.././././/./");
    console.log(routes);

    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {

      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        console.log("collapseActiveRoute");
        console.log(collapseActiveRoute);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        let categoryActiveRoute = getActiveRoute(routes[i].views);
        console.log("categoryActiveRoute");
        console.log(categoryActiveRoute);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        // const currentURL = window.location.href;
        // const routePattern = new RegExp(
        //   `^${routes[i].layout}${routes[i].path.replace(/:\w+/g, '\\w+')}$`
        // );

        // if (currentURL.match(routePattern)) {
        //   return routes[i].name;
        // }
        const locate = window.location
        console.log("locate?><?<:<:<:L:<");
        console.log(locate);

        const tttt = routes[i].path;
        const yyyy = tttt.split(":");
        const dynamicPart = yyyy[0];

        console.log("Route Name");
        console.log(routes[i].name);
        console.log(routes[i].layout + dynamicPart);
        
        if (window.location.href.indexOf(routes[i].layout + dynamicPart) !== -1
        ) {
          if (routes[i].name !== routes[i].base) {
            return <>
            
            <Link 
            // 
            onClick={handeGoback}
             style={{
              color: "white",
              fontSize: '25px',
              marginBottom: '20px'
            }}> <IoArrowBackSharp  /></Link> 
            <span style={{
              color: "white"
            }}></span> 
            {/* <a href="#" style={{
              color: "white"
            }}>{routes[i].name}</a> */}
            </>
          }
          else {
            return <span style={{
              color: "white"
            }}>{routes[i].name}</span>;
          }
        }
      }
    }
    return activeRoute;

  };

  // This changes navbar state(fixed or not)
  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbar(routes[i].views);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          if (routes[i].secondaryNavbar) {
            return routes[i].secondaryNavbar;
          }
        }
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.category === "account") {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  const { isOpen, onOpen, onClose } = useDisclosure();
  document.documentElement.dir = "ltr";
  // Chakra Color Mode



  return (
    <Box>

{designation === "Admin" && (
  <Box
    minH='40vh'
    w='100%'
    position='absolute'
    bgImage={colorMode === "light" ? bgAdmin : "none"}
    bg={colorMode === "light" ? bgAdmin : "navy.900"}
    bgSize='cover'
    top='0'
  />
)}

{(designation === "Plant Admin" || designation === dataConstant.GROUPROLE) && (
  <Box
    minH='40vh'
    w='100%'
    position='absolute'
    bgImage={colorMode === "light" ? bgPlantAdmin : "none"}
    bg={colorMode === "light" ? bgPlantAdmin : "navy.900"}
    bgSize='cover'
    bgPosition='center'
    bgRepeat='no-repeat'
    transform='scaleY(-1)' // Flips the image vertically
    top='0'
  />
)}

{designation === "City Admin" && (
  <Box
    minH='40vh'
    w='100%'
    position='absolute'
    bgImage={colorMode === "light" ? bgCityAdmin : "none"}
    bg={colorMode === "light" ? bgCityAdmin : "navy.900"}
    bgSize='cover'
    top='0'
  />
)}
{designation === "Corporate"  && (
  <Box
    minH='40vh'
    w='100%'
    position='absolute'
    bgImage={colorMode === "light" ? bgCityAdmin : "none"}
    bg={colorMode === "light" ? bgCityAdmin : "navy.900"}
    bgSize='cover'
    top='0'
  />
)}

    
      <Sidebar
        routes={routes}
        logo={
          <Stack direction='row' spacing='12px' align='center' justify='center'>
            {colorMode === "dark" ? (
              <ArgonLogoLight w='74px' h='27px' />
            ) : (
              <ArgonLogoDark w='74px' h='27px' />
            )}
            <Box
              w='1px'
              h='20px'
              bg={colorMode === "dark" ? "white" : "gray.700"}
            />
            {colorMode === "dark" ? (
              <ChakraLogoLight w='82px' h='21px' />
            ) : (
              <ChakraLogoDark w='82px' h='21px' />
            )}
          </Stack>
        }
        display='none'
        {...rest}
      />
      <MainPanel
        w={{
          base: "100%",
          xl: "calc(100% - 275px)",
        }}>
        <Portal>
          <AdminNavbar
            onOpen={onOpen}
            brandText={getActiveRoute(routes)}
            secondary={getActiveNavbar(routes)}
            fixed={fixed}
            {...rest}
          />
        </Portal>
        {getRoute() ? (
          <PanelContent>
            <PanelContainer>
              <Switch>
                {getRoutes(routes)}
                <Redirect from='/admin' to='/admin/dashboard' />
              </Switch>
            </PanelContainer>
          </PanelContent>
        ) : null}
        <Footer />
        {/* <Portal>
          <FixedPlugin
            secondary={getActiveNavbar(routes)}
            fixed={fixed}
            onOpen={onOpen}
          />
        </Portal> */}
        <Configurator
          secondary={getActiveNavbar(routes)}
          isOpen={isOpen}
          onClose={onClose}
          isChecked={fixed}
          onSwitch={(value) => {
            setFixed(value);
          }}
        />
      </MainPanel>
    </Box>
  );
}
